module.exports = __webpack_public_path__ + "static/media/icon_trade_arrow.44a9f455.svg";